import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { DynamicForm } from "@shared/components/DynamicForm";
import { FormField } from "@shared/services/FormServices";
import { BUTTON_FIELD_CLASSES } from "@shared/utils/constants";
import { useUtilityServices } from "@features/cx/consumerOnboarding/hooks";

interface ConnectionsFilterProps {
  form: UseFormReturn<any>;
  onApply: (data: any) => void;
  onReset: () => void;
}

export const ConnectionsFilter: React.FC<ConnectionsFilterProps> = ({
  form,
  onApply,
  onReset,
}) => {
  const { data: utilityData } = useUtilityServices();

  const getUtilityOptions = useMemo(
    () =>
      utilityData
        ? utilityData
            .filter((utility: any) => utility.isActive === true)
            .map((utility: any) => ({
              value: utility.name,
              label: utility.name,
            }))
        : [],
    [utilityData],
  );

  const fields: FormField[] = [
    {
      name: "utility_service",
      label: "Utility Service",
      type: "select",
      placeholder: "Select Utility Service",
      options: getUtilityOptions,
    },
  ];

  const handleReset = () => {
    form.reset({
      utility_service: "",
    });
    onReset();
  };

  return (
    <div className="space-y-4">
      <DynamicForm
        fields={fields}
        form={form}
        gridColumns={1}
        responsiveColumns={{ sm: 1, md: 1 }}
        onSubmit={onApply}
        onReset={handleReset}
        config={{
          showResetButton: true,
          resetButtonText: "Reset",
          submitButtonText: "Apply Filters",
          classes: BUTTON_FIELD_CLASSES,
        }}
      />
    </div>
  );
};

export default ConnectionsFilter;
